import React from 'react'
import styled from 'styled-components'

import FeatureHeroCarousel from '../../../components/FeatureHeroCarousel'
import buildImageUrl from '../../../../lib/media-url-maker'

const ContentFrame = styled.div`
  width: 100%;
  max-width: 1360px;
  margin-left: auto;
  margin-right: auto;
`

const FeatureHeroCarouselWidget = ({ items = [] }) => {
  items = items.map((item) => {
    item.src =
      item.images.widgets.length > 0 &&
      buildImageUrl({
        width: 1360,
        mode: 'cover',
        resource:
          item.images.widgets[0].crops &&
          item.images.widgets[0].crops[0] &&
          item.images.widgets[0].crops[0].src
      })
    return item
  })

  return (
    <ContentFrame>
      <FeatureHeroCarousel slides={items} />
    </ContentFrame>
  )
}

export default FeatureHeroCarouselWidget
